<div class="role-details flex flex-col h-screen px-4 py-6 box-border"   *ngIf="!canAccess">
  <!-- Toolbar -->
  <p-toolbar styleClass="mb-4">
    <ng-template #start>
      <p-button label="New Role Group" icon="pi pi-plus" severity="secondary" (click)="openNew()" class="mr-2" />
    </ng-template>
      <ng-template pTemplate="end">   <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (onClick)="goBack()"></p-button></ng-template>
  </p-toolbar>

  <!-- Table -->
  <div class="table-box flex-1 overflow-auto">
    <p-table
      #dt
      [value]="roleGroups"
      [(selection)]="selectedRoles"
      selectionMode="multiple"
      dataKey="id"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20]"
      [responsiveLayout]="'scroll'"
      [globalFilterFields]="['name', 'description']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} roles"
      [showCurrentPageReport]="true"
      class="p-datatable-sm w-full"
    >
      <ng-template #caption>
        <div class="flex items-center justify-between flex-wrap gap-2">
          <h5 class="m-0 font-semibold">Role Groups</h5>
          <p-iconfield>
            <p-inputicon styleClass="pi pi-search" />
            <input
              pInputText
              type="text"
              (input)="onGlobalFilter(dt, $event)"
              placeholder="Search..."
              class="p-inputtext-sm"
            />
          </p-iconfield>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th pSortableColumn="name">Role Group Name <p-sortIcon field="name" /></th>
          <th pSortableColumn="description">Description <p-sortIcon field="description" /></th>
          <!-- <th pSortableColumn="isActive">Status <p-sortIcon field="isActive" /></th> -->
          <th>Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-role>
        <tr [pSelectableRow]="role">
          <td><p-tableCheckbox [value]="role"></p-tableCheckbox></td>
          <td>{{ role.name }}</td>
          <td>{{ role.description }}</td>
          <!-- <td>{{ getStatusLabel(role.isActive) }}</td> -->
          <td>
            <p-button
              icon="pi pi-pencil"
              class="mr-2"
              (click)="editRole(role)"
              [rounded]="true"
              [outlined]="true"
              severity="info"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              (click)="deleteRole(role)"
              [rounded]="true"
              [outlined]="true"
              severity="danger"
            ></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Dialog -->
  <p-dialog
    header="{{ editingRoleId ? 'Edit Role' : 'New Role' }}"
    [(visible)]="roleDialog"
    [modal]="true"
    [closable]="false"
    [resizable]="false"
    [draggable]="false"
    [style]="{ width: '450px' }"
  >
    <ng-template #content>
      <div class="mb-4">
        <label for="name" class="block font-bold mb-2">Role Group Name</label>
        <input
          id="name"
          type="text"
          pInputText
          [(ngModel)]="roleForm.name"
          name="name"
          required
          autofocus
          class="w-full"
        />
        <small class="text-red-500" *ngIf="submitted && !roleForm.name">Role Group Name is required.</small>
      </div>

      <div class="mb-4">
        <label for="desc" class="block font-bold mb-2">Description</label>
        <input
          id="desc"
          type="text"
          pInputText
          [(ngModel)]="roleForm.description"
          name="description"
          required
          class="w-full"
        />
        <small class="text-red-500" *ngIf="submitted && !roleForm.description">Description is required.</small>
      </div>
    </ng-template>

    <ng-template #footer>
      <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
      <p-button
        label="Save"
        icon="pi pi-check"
        (click)="saveRole()"
        [disabled]="!roleForm.name || !roleForm.description"
      />
    </ng-template>
  </p-dialog>

  <!-- Toast + Confirm -->
  <p-confirmDialog></p-confirmDialog>
  <p-toast></p-toast>

  <style>

    .table-box {
  
      border-radius: 0.75rem;
      box-shadow: var(--shadow-2);
      padding: 1.5rem;
      min-height: 300px;
    }

    .p-datatable-sm {
      font-size: 1rem !important;
    }

    .mb-4 {
      margin-bottom: 1.25rem;
    }

    .w-full {
      width: 100%;
    }

    .p-dialog .p-dialog-content,
    .p-dialog .p-dialog-header,
    .p-dialog .p-dialog-footer {
      font-size: 1rem;
    }
  </style>
</div>
